<template>
  <div>
    <van-nav-bar fixed left-arrow @click-left="onClickLeft">
      <template #left>
        <van-icon color="white" name="arrow-left" size="18" />
      </template>
      <template #title>
        <span class="navbar_title">{{ title }}</span>
      </template>
    </van-nav-bar>
    <div class="nav-placeholder"></div>
    <van-form @submit="onSubmit">
      <van-field
        :readonly="type == 1"
        v-model="person.name"
        colon
        name="name"
        label="姓名"
        placeholder="请输入姓名"
      >
        <template #left-icon>
          <van-icon :name="user_icon" size="14"></van-icon>
        </template>
      </van-field>
      <van-field
        v-model="person.tel"
        :readonly="type == 1"
        colon
        name="tel"
        label="电话号码"
        placeholder="请输入电话号码"
        type="tel"
      >
        <template #left-icon>
          <van-icon :name="icon_phone"></van-icon>
        </template>
        <template #input v-if="type == 1">
          {{ person.tel }}（<a class="phone" :href="'tel:' + person.tel">呼叫</a
          >）
        </template>
      </van-field>
      <van-field
        :value="formatSchool(person.schools)"
        colon
        readonly
        name="schools"
        label="管理学校"
        placeholder="请选择管理的学校"
        type="textarea"
        autosize
        rows="1"
        :is-link="type != 1"
        @click="openCheckbox"
      >
        <template #left-icon>
          <van-icon :name="school_icon"></van-icon>
        </template>
      </van-field>
      <van-popup
        round
        position="bottom"
        v-model="show_checkbox"
        :style="{ height: '300px' }"
      >
        <Checkbox
          @onConfirm="selectSchool"
          @onCancel="selectSchoolCancel"
          :maintainAreas="maintainAreas"
          :checkedMaintainAreas="person.schools"
        ></Checkbox>
      </van-popup>
      <div style="margin: 16px" v-if="type != 1">
        <van-button
          round
          block
          class="btn_submit"
          type="info"
          native-type="submit"
          >提交</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
import { Toast } from "vant";
import Checkbox from "./components/Checkbox";
import { getMaintainAreas } from "../../api/maintenance";
export default {
  name: "UpdateDetail",
  data() {
    return {
      user_icon: require("../../assets/icon/maintenance/user_icon.png"),
      icon_phone: require("../../assets/icon/phone_icon.png"),
      school_icon: require("../../assets/icon/room_icon.png"),
      phone_regular: /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/,
      title: "",
      person: {
        id: "",
        name: "",
        tel: "",
        schools: [],
      },
      type: "", //1.详情页面
      show_checkbox: false,
      maintainAreas: [],
    };
  },
  components: {
    Checkbox,
  },
  created() {
    let query = this.$route.query;
    let dataStr = query.data;
    this.title = query.title;
    this.type = query.type;
    if (dataStr) {
      let data = JSON.parse(dataStr);
      Object.assign(this.person, {
        id: data.maintainId,
        name: data.maintainName,
        tel: data.maintainTel,
        schools: data.schools,
        type: data.type,
      });
    }
    // this.computed.getMaintainAreas();
    this.maintainAreas = this.getMaintainAreas;
  },
  computed: {
    formatSchool(schools) {
      return function (schools) {
        let names = [];
        for (const iter of schools) {
          names.push(iter.schoolName);
        }
        return names.join(",");
      };
    },
    getMaintainAreas() {
      return this.$store.getters.maintainAreas;
    },
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    async onSubmit(values) {
      //先验证
      if (!values.name) {
        Toast("请填写姓名!");
        return;
      } else if (!this.phone_regular.test(values.tel.trim())) {
        Toast("请填写正确的手机号!");
        return;
      } else if (!values.schools) {
        Toast("请选择管理的学校!");
        return;
      }
      let data = {
        maintainId: this.person.id,
        maintainName: this.person.name,
        maintainTel: this.person.tel,
        schools: this.person.schools.map((v) => {
          return v.schoolId;
        }),
      };
      //判断是更新还是新增
      let res = "";
      if (this.person.id) {
        res = await this.$store.dispatch("updateMaintain", data);
      } else {
        res = await this.$store.dispatch("addMaintain", data);
      }
      if (res.success) {
        Toast.success(this.title + "成功!");
        this.$router.go(-1);
      } else {
        Toast.fail(res.msg);
      }
    },
    selectSchool(values, show) {
      this.show_checkbox = show;
      this.person.schools = values;
    },
    selectSchoolCancel(show) {
      this.show_checkbox = show;
    },
    //打开弹窗选择shcool组件
    async openCheckbox() {
      if (this.type == 1) {
        return;
      }
      if (this.maintainAreas.length <= 0) {
        //请求学校接口传给组件
        let res = await this.$store.dispatch("getMaintainAreas");
        if (res.success) {
          this.maintainAreas = res.data.schools;
        } else {
          Toast.fail(res.msg);
        }
      }
      this.show_checkbox = true;
    },
  },
};
</script>

<style scoped>
.van-nav-bar {
  background: #ba3939;
}
.navbar_title {
  color: #ffffff !important;
}
.nav-placeholder {
  height: 92px;
}
.btn_submit {
  background: #ba3939;
  border: 1px solid #dd524d;
}
</style>